import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Product from '../views/Product.vue'
import Support from '../views/Support.vue'
import Errpage from '../views/404.vue'
import Content from '../views/Content.vue'
import Zendesk from '../views/Zendesk.vue'
import ZendeskZh from '../views/Zendesk-zh.vue'
import Get from '../views/Get.vue'
import TermsofUse from '../views/TermsofUse.vue'
import Privacy from '../views/Privacy.vue'
import Search from '../views/Search.vue'
import SupportZh from '../views/Support-zh.vue'
import GetZh from '../views/Get-zh.vue'
import ProductZh from '../views/Product-zh.vue'
import SearchZh from '../views/Search-zh.vue'
import Contentweb from '../views/Contentweb.vue'
import ContentwebZh from '../views/Contentweb-zh.vue'
import Test from "../views/Test.vue";
//页面路径

const routes = [{
        path: '/',
        name: 'Product', //产品页，主页
        component: Product
    }, {
        path: '/zh',
        name: 'ProductZh', //产品页，主页
        component: ProductZh
    }, {
        path: '/support/',
        name: 'Support', //支持页
        component: Support
    }, {
        path: '/support-zh/',
        name: 'Support-zh', //支持页
        component: SupportZh
    }, {
        path: '/content',
        name: 'Content', //文章通用样式
        component: Content
    }, {
        path: '/submit-a-ticket',
        name: 'Zendesk', //zendesk表单
        component: Zendesk
    }, {
        path: '/submit-a-ticket-zh',
        name: 'ZendeskZh', //zendesk表单
        component: ZendeskZh
    }, {
        path: '/en/terms-of-use/',
        name: 'TermsofUse',
        component: TermsofUse
    }, {
        path: '/en/privacy-policy',
        name: 'Privacy',
        component: Privacy
    }, {
        path: '/search',
        name: 'Search',
        component: Search
    }, {
        path: '/search-zh',
        name: 'SearchZh',
        component: SearchZh
    }, {
        path: '/get',
        name: 'Get',
        component: Get
    }, {
        path: '/get-zh',
        name: 'GetZh',
        component: GetZh
    },
    {
        path: '/support/:title/',
        name: 'contentWeb',
        component: Contentweb
    },
    {
        path: '/support-zh/:title/',
        name: 'contentWebZh',
        component: ContentwebZh
    }, {
        path: '/test',
        name: 'test',
        component: Test
    },
    { //路径写法不兼容
        path: '/:pathMatch(.*)', //https://next.router.vuejs.org/zh/guide/migration/index.html#%E5%88%A0%E9%99%A4%E4%BA%86-routeroptions-%E4%B8%AD%E7%9A%84-fallback-%E5%B1%9E%E6%80%A7
        name: '404',
        component: Errpage
    },

]

const router = createRouter({
    history: createWebHistory("/"),
    routes
})

export default router